module.exports = __webpack_public_path__ + "assets/scrolling-list-loader.cec983ea9d60643bdea294af4ab817f1.svg";